import { useQuery } from '@tanstack/react-query'
import { configAjax } from '../ajax/ConfigAjax'
import { ErrorResponse } from '../DTOs/Common/ErrorResponse'

export function useShiftBands() {
  return useQuery({
    queryKey: ['config', 'shiftBands'],
    queryFn: async () => {
      const res = await configAjax.getShiftBands()
      if (ErrorResponse.isErrorResponse(res)) return null
      return res
    },
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24 * 7,
  })
}
